var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered"},[_c('h1',{staticClass:"text-shadow"},[_vm._v("\n    Shop AHL Coming soon!\n  ")])])}]

export { render, staticRenderFns }